// XState events that return nothing.
export const emptyEvent = () => ({});

// XState events that return their parameters.
export const passthroughEvent = <T>(payload: T) => payload;
